import React from 'react';
import {connect} from "react-redux";
import {authValidateToken} from "../../redux/actions/users";
import {CircularProgress} from "material-ui";
import {setActiveCompanyId} from "../../redux/actions/app";

export class Authenticate extends React.Component {

    componentDidMount = () => {
        if (JSON.stringify(this.props.currentUser) === JSON.stringify({})) {
            this.props.authentication();
        } else {
            this.props.mount(this.props.currentUser.company_id);
        }
    };

    componentDidUpdate = () => {
        if (JSON.stringify(this.props.currentUser) === JSON.stringify({})) {
            this.props.authentication();
        }
    };

    render() {
        return (
            JSON.stringify(this.props.currentUser) === JSON.stringify({}) ?
                <CircularProgress/> :
                this.props.children
        )
    }
}

Authenticate = connect(
    (state) => {
        return {
            activeCompanyId: state.app.activeCompanyId,
            currentUser: state.users.currentUser,
        }
    },
    (dispatch) => {
        return {
            authentication: () => {
                dispatch(authValidateToken()).then((response) => {
                    if (response.type === 'API_AUTH_VALIDATE_TOKEN_SUCCESS') {
                        dispatch(setActiveCompanyId(response.payload.data.data.company_id));
                    }
                });
            },
            mount: (company_id) => {
                dispatch(setActiveCompanyId(company_id));
            }
        }
    }
)(Authenticate);


// WEBPACK FOOTER //
// ./src/components/authenticate/index.js